import styled from "styled-components";
export const PrinterPackslipBtn = styled.button`
  cursor: pointer;
  border: 1px solid #0071bc;
  border-radius: 4px;
  background: #fff;
  color: #0071bc;
  padding: 8px 20px;
  font-weight: 500;
  max-width: 200px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  :hover,
  :active,
  :focus {
    background: #0071bc;
    color: #fff;
  }
`;
export const ContinueBtn = styled.button`
  cursor: pointer;
  border: 1px solid #0071bc;
  border-radius: 4px;
  color: #0071bc;
  padding: 8px 20px;
  font-weight: 500;
  max-width: 200px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  :hover,
  :active,
  :focus {
    background: #0071bc;
    color: #fff;
  }
`;
export const PSPrinterWrappers = styled.div``;
export const PSPrinterModalWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  width: 100%;
`;
